import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
import { request } from '@/api/service';
export default {
  name: 'sms-recharge',
  props: {
    src: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      url: ''
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var mobile, market_id, that;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              mobile = _this.$route.query.market_mobile;
              market_id = _this.$route.query.market_id;
              that = _this;
              _context.next = 5;
              return _this.$store.dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'user.info',
                defaultValue: {},
                user: true
              }, {
                root: true
              });

            case 5:
              _this.userInfo = _context.sent;
              console.log('---------------userinfo sms', _this.userInfo);
              request({
                method: 'post',
                url: '/api/sms-recharge/create',
                data: {
                  'market_id': _this.userInfo.market_id
                }
              }).then(function (res) {
                var app_id = res.app_id;
                var sign = res.sign;
                var market_id = res.market_id;
                var order_no = res.order_no;
                var src = res.src;
                var sms_count = res.sms_count;
                _this.url = src + '?app_id=' + app_id + '&sign=' + sign + '&market_id=' + market_id + '&order_no=' + order_no + '&sms_count=' + sms_count;
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};